module.exports = __webpack_public_path__ + "static/media/copy.87d72c1a.svg";